import { Questao } from './../models/questao.model';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from "src/app/services/base.service";

@Injectable()
export class QuestaoService extends BaseService{

    buscar(texto:string='',categorizada:boolean,pagina:number) :Observable<any> {
        let url: string='edicao-conteudos/questoes/buscar-por-titulo/'+categorizada+'/'+texto+'/'+pagina;
       
    var result = this.get(url);
    return result;
    }
    obterAreasConhecimento():Observable<any>{
        let url:string='areas-conhecimento';
        var result=this.get(url);
        return result;
    }
    obterSegmentos():Observable<any>{
        let url:string='segmentos';
        var result=this.get(url);
        return result;
    }
    obterHabilidades():Observable<any>{
        let url:string='habilidades';
        var result=this.get(url);
        return result;
    }
    obterQuestaoPorId(id:string):Observable<any>{
        let url:string='edicao-conteudos/questoes/'+id;
        var result=this.get(url);
        return result;
    }
    obterAreasConhecimentoSegmentos():Observable<any>
    {
        let url:string='questoes/areas-conhecimento-segmentos';
        var result=this.get(url);
        return result;
    }
    obterHAbilidades(porCodigo:boolean,texto:string):Observable<any>
    {
        let url:string='questoes/habilidades/'+porCodigo+'/'+texto;
        var result=this.get(url);
        return result;
    }
    atualizarQuestao(data: Questao):Observable<any>
    {
        let url:string='edicao-conteudos/questoes/atualizar';
        var result=this.put(url, data);
        return result;
    }
}
//https://localhost:44302/api/edicao-conteudos/questoes/buscar-por-titulo/false/2019/1